import { render, staticRenderFns } from "./ScoreBreakdownPopup.vue?vue&type=template&id=9ac43fa8&scoped=true&"
import script from "./ScoreBreakdownPopup.vue?vue&type=script&lang=js&"
export * from "./ScoreBreakdownPopup.vue?vue&type=script&lang=js&"
import style0 from "./ScoreBreakdownPopup.vue?vue&type=style&index=0&id=9ac43fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac43fa8",
  null
  
)

export default component.exports